import React, { useEffect, useState, useMemo } from "react";
import withRouter from "components/Common/withRouter";
import TableContainer from "components/Common/TableContainer";
import {
  Card, CardBody, Col, Container, Row, Spinner, Button,
  Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import axios from "axios";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const API_BASE = "https://maasradarapi.stechomeyazilim.info";

const CitiesList = () => {
  document.title = "Şehirler | Maaş Radar Admin Paneli";

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState({});

  const [addModal, setAddModal] = useState(false);
  const [newName, setNewName] = useState("");

  function getAuthHeaders() {
    const token = localStorage.getItem("token");
    return { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" };
  }

  const fetchItems = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE}/Cities`, { headers: getAuthHeaders() });
      setItems(res.data.value || []);
    } catch (error) {
      console.error("Veriler alınamadı", error);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchItems(); }, []);

  const showToast = (success, message) => {
    toastr.options = { positionClass: "toast-top-right", timeOut: 5000, closeButton: true, progressBar: true };
    if (success) toastr.success(message, "Başarılı");
    else toastr.error(message, "Hata");
  };

  const handleAdd = async () => {
    if (!newName.trim()) return;
    setProcessing(p => ({ ...p, ["add"]: true }));
    try {
      await axios.post(`${API_BASE}/Cities`, { Name: newName }, { headers: getAuthHeaders() });
      showToast(true, "Şehir eklendi.");
      setAddModal(false);
      setNewName("");
      fetchItems();
    } catch (err) {
      console.error(err);
      showToast(false, "Ekleme sırasında hata oluştu.");
    } finally {
      setProcessing(p => ({ ...p, ["add"]: false }));
    }
  };

  const handleDelete = (id) => {
    if (!window.confirm("Bu şehri silmek istediğinize emin misiniz?")) return;
    setProcessing(p => ({ ...p, [id + "delete"]: true }));
    axios.delete(`${API_BASE}/Cities(${id})`, { headers: getAuthHeaders() })
      .then(() => { showToast(true, "Şehir silindi."); fetchItems(); })
      .catch((err) => { console.error(err); showToast(false, "Silme sırasında hata oluştu."); })
      .finally(() => setProcessing(p => ({ ...p, [id + "delete"]: false })));
  };

  const columns = useMemo(() => [
    { Header: "ID", accessor: "Id", width: "80px" },
    { Header: "Ad", accessor: "Name" },
    {
      Header: "İşlemler", accessor: "actions", disableSortBy: true,
      Cell: ({ row }) => (
        <Button size="sm" color="danger" disabled={processing[row.original.Id + "delete"]} onClick={() => handleDelete(row.original.Id)}>
          {processing[row.original.Id + "delete"] ? <Spinner size="sm" /> : "Sil"}
        </Button>
      )
    }
  ], [processing]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Şehirler" breadcrumbItem="Liste" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="mb-3">
                    <Button color="success" onClick={() => setAddModal(true)}>Yeni Şehir Ekle</Button>
                  </div>
                  {loading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer columns={columns} data={items} isGlobalFilter={true} isAddOptions={false} customPageSize={10} className="custom-header-css" />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal isOpen={addModal} toggle={() => setAddModal(false)}>
        <ModalHeader toggle={() => setAddModal(false)}>Yeni Şehir Ekle</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label>Şehir Adı</Label>
              <Input type="text" value={newName} onChange={(e) => setNewName(e.target.value)} />
            </FormGroup>
            <Button color="primary" disabled={processing["add"]} onClick={handleAdd}>
              {processing["add"] ? <Spinner size="sm" /> : "Ekle"}
            </Button>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(CitiesList);
